import { render, staticRenderFns } from "./CounterWidget.vue?vue&type=template&id=4db2d0cf&scoped=true&lang=pug"
import script from "./CounterWidget.vue?vue&type=script&lang=js"
export * from "./CounterWidget.vue?vue&type=script&lang=js"
import style0 from "./CounterWidget.vue?vue&type=style&index=0&id=4db2d0cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2d0cf",
  null
  
)

export default component.exports